var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M336.788 330.301c-23.375 17.894-50.901 28.32-80.784 28.32-29.892 0-57.418-10.427-80.797-28.32C73.459 351.183 0 410.249 0 480h512c0-69.751-73.46-128.817-175.212-149.699zM150.753 176a105.247 144 12240 10210.494 0 105.247 144 12240 10-210.494 0z"}));
}

User.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = User;

User.default = User;
